import { render, staticRenderFns } from "./licai2.vue?vue&type=template&id=84fcba96&scoped=true&"
import script from "./licai2.vue?vue&type=script&lang=js&"
export * from "./licai2.vue?vue&type=script&lang=js&"
import style0 from "./licai2.vue?vue&type=style&index=0&id=84fcba96&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fcba96",
  null
  
)

export default component.exports